import { render } from "./collection-listing.vue?vue&type=template&id=fc708d00"
import script from "./collection-listing.vue?vue&type=script&lang=js"
export * from "./collection-listing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__